var render = function render(){var _vm=this,_c=_vm._self._c;return _c('SortSearch',{attrs:{"default-sort":"trending","dimension":"TrendingDesigns","force-experience":_vm.getMerch,"query":"Y2k"}})
}
var staticRenderFns = []

export { render, staticRenderFns }